var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "s-form-input"
  }, [_c('Field', {
    attrs: {
      "name": _vm.name,
      "label": _vm.label,
      "error": _vm.error,
      "help": _vm.help
    }
  }, [_c('div', {
    staticClass: "s-relative"
  }, [_c('input', {
    staticClass: "s-form-control",
    attrs: {
      "id": _vm.name,
      "name": _vm.name,
      "type": _vm.showPassword ? 'text' : _vm.type,
      "pattern": _vm.pattern,
      "maxlength": _vm.maxlength,
      "inputmode": _vm.inputmode,
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled,
      "required": _vm.required,
      "readonly": _vm.readonly
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function input($event) {
        return _vm.$emit('input', $event.target.value);
      }
    }
  }), _vm.type === 'password' ? _c('div', {
    staticClass: "s-eye-icon",
    on: {
      "click": function click($event) {
        _vm.showPassword = !_vm.showPassword;
      }
    }
  }, [_vm.showPassword ? _c('img', {
    attrs: {
      "src": require("@/assets/images/liff/eye.png")
    }
  }) : _c('img', {
    attrs: {
      "src": require("@/assets/images/liff/eye-slash.png")
    }
  })]) : _vm._e()])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }